import { render, staticRenderFns } from "./ListSaleQuotation.vue?vue&type=template&id=67ff3d3a&"
import script from "./ListSaleQuotation.vue?vue&type=script&lang=js&"
export * from "./ListSaleQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports